import { render, staticRenderFns } from "./AuthUpdatePassword.vue?vue&type=template&id=4661d012"
import script from "./AuthUpdatePassword.vue?vue&type=script&lang=js"
export * from "./AuthUpdatePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports